import React from 'react';
import notify from './utils/notify';
import './WhatsAppShareModal.css';

const WhatsAppShareModal = ({ isOpen, onClose, roundPlayersData, isMobileView, title, text, shareUrl }) => {
  if (!isOpen) return null;

  const isGenericMode = !!text || !!shareUrl;

  const formatWhatsAppMessage = (data) => {
    if (isGenericMode) {
      let msg = text || '';
      if (shareUrl) msg += `\n\n${shareUrl}`;
      msg += "\n\n_Powered by GolfApp_";
      return encodeURIComponent(msg);
    }

    let message = "*Handicap Adjustments for Latest Round*\n\n";
    (data || []).forEach(player => {
      const playerName = player.name || 'Unknown Player';
      const previousHcp = player.previous_handicap_index !== undefined && player.previous_handicap_index !== null ? player.previous_handicap_index.toFixed(1) : 'N/A';
      const adjustmentVal = player.adjustment !== undefined && player.adjustment !== null ? player.adjustment.toFixed(1) : 'N/A';
      const newHcp = player.new_handicap_index !== undefined && player.new_handicap_index !== null ? player.new_handicap_index.toFixed(1) : 'N/A';
      
      const adjustmentSign = player.adjustment >= 0 ? '+' : '';
      
      message += `*${playerName}*: Previous HCP: ${previousHcp}, Adjustment: ${adjustmentSign}${adjustmentVal}, New HCP: ${newHcp}\n`;
    });
    message += "\n_Powered by GolfApp_";
    return encodeURIComponent(message);
  };

  const handleShare = () => {
    const message = formatWhatsAppMessage(roundPlayersData);
    const whatsappUrl = `https://wa.me/?text=${message}`;
    window.open(whatsappUrl, '_blank');
    onClose(); 
  };

  const copyToClipboard = () => {
    const fullText = shareUrl ? `${text}\n\n${shareUrl}` : text;
    navigator.clipboard.writeText(fullText).then(() => {
      notify.success('Link copied');
    });
  };

  return (
    <div className="whatsapp-share-modal-overlay" onClick={onClose}>
      <div className="whatsapp-share-modal-content" onClick={e => e.stopPropagation()}>
        <h2>{title || (isGenericMode ? "Share Invite" : "Handicap Adjustments Applied!")}</h2>
        <p>{isGenericMode ? "Share this invite with your players:" : "Would you like to share the new handicaps on WhatsApp?"}</p>
        
        {isGenericMode ? (
          <div className="whatsapp-invite-preview">
            <div className="invite-box">
              {text}
              {shareUrl && <div className="invite-url">{shareUrl}</div>}
            </div>
            <button className="copy-link-btn" onClick={copyToClipboard}>
              Copy to Clipboard
            </button>
          </div>
        ) : (
          <div className="whatsapp-adjustment-summary">
            {(roundPlayersData || []).map((player, index) => {
              const playerName = player.name || 'Unknown Player';
              const previousHcp = player.previous_handicap_index !== undefined && player.previous_handicap_index !== null ? player.previous_handicap_index.toFixed(1) : 'N/A';
              const adjustmentVal = player.adjustment !== undefined && player.adjustment !== null ? player.adjustment.toFixed(1) : 'N/A';
              const newHcp = player.new_handicap_index !== undefined && player.new_handicap_index !== null ? player.new_handicap_index.toFixed(1) : 'N/A';
              const adjustmentSign = player.adjustment >= 0 ? '+' : '';

              return (
                <p key={index}>
                  <strong>{playerName}:</strong> Previous HCP: {previousHcp}, Adjustment: {adjustmentSign}{adjustmentVal}, New HCP: {newHcp}
                </p>
              );
            })}
          </div>
        )}

        <div className="whatsapp-share-modal-actions">
          <button className="whatsapp-share-button" onClick={handleShare}>Share on WhatsApp</button>
          <button className="whatsapp-cancel-button" onClick={onClose}>No Thanks</button>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppShareModal;
